<template>
  <div class="news-page">
    <transition name="fade">
      <div class="main-container">
        <div class="headline-1">
          <b>绿展新闻</b>
        </div>
        <div class="news-container">
          <div
            class="news-item"
            :key="news.id"
            v-for="news in newsList"
            @click="goDetail(news)"
          >
            <div class="date">{{news.date_published | date('MMM DD, YYYY')}}</div>
            <img :src="news.image" class="preview-image" />
            <h4 class="title" v-html="news.title"></h4>
            <p class="summary" v-html="news.summary? news.summary.substring(0, 90) + '...' : ''"></p>
          </div>
        </div>
        <div class="load-more">
          <button v-if="canLoadMore" class="gp-button" @click="loadMore">load more ...</button>
        </div>
      </div>
    </transition>
    <GPFooter />
  </div>
</template>
<style lang="scss" src="./NewsPage.scss"></style>

<script>
import DataService from '../services/DataService'
export default {
  name: 'NewsPage',
  props: {
  },
  data () {
    return {
      newsList: [],
      result: [],
      currentPage: 1,
      numPerPage: 12,
      canLoadMore: true
    }
  },
  methods: {
    loadMore () {
      this.newsList = [...this.newsList, ...this.result[this.currentPage]]
      this.currentPage++
      if (this.result.length === this.currentPage) {
        this.canLoadMore = false
      }
    },
    convertURLtoID (str) {
      const from = str.lastIndexOf('/') + 1
      const to = str.lastIndexOf('.html')
      return str.slice(from, to)
    },
    goDetail (item) {
      this.$router.push({
        name: 'News_detail',
        params: {
          id: this.convertURLtoID(item.id)
        }
      })
    }
  },
  created () {
  },
  mounted () {
    DataService.getNewsList().then((response) => {
      const items = response
      for (var i = 0; i < items.length; i += this.numPerPage) {
        this.result.push(items.slice(i, i + this.numPerPage))
      }
      if (this.result.length === this.currentPage) {
        this.canLoadMore = false
      }
      this.newsList = this.result[0]
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/NewsPage.vue